export const memberPointsRoutes = {
  MEMBER_POINTS_MALL: 'memberPointsMall',
}

export default [
  {
    name: 'memberPointsIndex',
    path: '/memberPoints/index',
    meta: { title: '积分商城' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsIndexRouterView" */ '../../pages/memberPoints/indexRouterView'
      ),
  },
  {
    name: 'memberPointsProduct',
    path: '/memberPoints/product/:actId',
    meta: { title: '商品详情' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsProduct" */ '../../pages/memberPoints/product'
      ),
  },
  {
    name: memberPointsRoutes.MEMBER_POINTS_MALL,
    path: '/memberPoints/mall',
    meta: { title: '积分兑换' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsMall" */ '../../pages/memberPoints/mall'
      ),
  },
  {
    name: 'memberPointsOrder',
    path: '/memberPoints/order',
    meta: { title: '兑换记录' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsOrder" */ '../../pages/memberPoints/order'
      ),
  },
  {
    name: 'memberPointsSuccess',
    path: '/memberPoints/success/:type',
    meta: { title: '商品兑换' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsSuccess" */ '../../pages/memberPoints/success'
      ),
  },
  {
    name: 'memberPointsTask',
    path: '/memberPoints/task',
    meta: { title: '任务' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsTaskRouterView" */ '../../pages/memberPoints/taskRouterView'
      ),
  },
  {
    name: 'memberPointsRoom',
    path: '/memberPoints/room',
    meta: { title: '直播间' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsRoom" */ '../../pages/memberPoints/room'
      ),
  },
  {
    name: 'memberPointsBill',
    path: '/memberPoints/bill',
    meta: { title: '积分明细' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsBillRouterView" */ '../../pages/memberPoints/billRouterView'
      ),
  },
  {
    name: 'memberPointsRule',
    path: '/memberPoints/rule',
    meta: { title: '规则说明' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsRuleRouterView" */ '../../pages/memberPoints/ruleRouterView'
      ),
  },
  {
    name: 'memberPointsSign',
    path: '/memberPoints/sign',
    meta: { title: '签到' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsSignRouterView" */ '../../pages/memberPoints/signRouterView'
      ),
  },
  {
    name: 'memberPointsFailed',
    path: '/memberPoints/failed',
    meta: { title: '兑换失败' },
    component: () =>
      import(
        /* webpackChunkName: "memberPointsSignRouterView" */ '../../pages/memberPoints/components/memberPointsFailed'
      ),
  },
]
